import { GetServerSideProps } from 'next'

import { tagMap } from '@/utils/constants'
import { serverSidePropsFor } from '@/utils/helpers.server'

import AverageDecksPage from '.'

export const getServerSideProps: GetServerSideProps = async ({ query, req }) => {
  const subDirs = (query.slug as string[]).map((slug: string) =>
    slug in tagMap ? tagMap[slug as keyof typeof tagMap] : slug,
  )
  const resolvedUrl = subDirs.length > 0 ? `/${subDirs.join('/')}` : ''
  return serverSidePropsFor(
    `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL_CLOUDFLARE}/pages/average-decks/${query.commander}${resolvedUrl}.json`,
    req.headers,
  )
}

export default AverageDecksPage
